<template>
  <div class="factory-send-dialog">
    <custom-dialog width="1200px" :title="model.title" :visible="visible" v-on="$listeners">
      <div class="dialog-body">
        <h1 class="title" style="margin-bottom: 15px">{{ $t('crm_factory_send_plan.fa_huo_ji_hua_biao') }}</h1>
        <div style="margin-bottom: 40px">
          <custom-table tableCode="handleFactorySendPlan" :data="tableList" :slots="['consignee']">
            <template slot="consignee" slot-scope="scope">
              <el-tooltip placement="bottom" effect="light">
                <div slot="content">
                  <div style="padding: 2px 8px">
                    <p style="font-size: 14px; line-height: 24px">{{ $t('crm_factory_send_plan.shou_huo_ren') }}： {{ scope.row.consigneeName }}</p>
                    <p style="font-size: 14px; line-height: 24px">{{ $t('crm_factory_send_plan.dian_hua') }}： {{ scope.row.consigneePhone }}</p>
                    <p style="font-size: 14px; line-height: 24px">{{ $t('crm_factory_send_plan.di_zhi') }}： {{ scope.row.consigneeAddress }}</p>
                  </div>
                </div>
                <el-button type="text">{{ scope.row.consigneeName }}</el-button>
              </el-tooltip>
            </template>
          </custom-table>
        </div>
        <div class="ub">
          <div class="ub-f1" style="width: 0">
            <div class="search-hd">
              <el-form :inline="true" @submit.native.prevent>
                <el-form-item>
                  <h1 class="title">{{ $t('crm_factory_send_plan.ke_fa_huo_lie_biao') }}</h1>
                </el-form-item>
                <el-form-item style="float: right; margin-right: 0">
                  <el-input
                    :placeholder="$t('crm_factory_send_plan.qsrjsh')"
                    v-model="formSearch.search"
                    clearable
                    @keyup.enter.native="onPageChange({ page: 1 })"
                    @blur="onPageChange({ page: 1 })"
                    style="width: 320px"
                  >
                    <el-select v-model="formSearch.productCodes" slot="prepend" :placeholder="$t('Common.com_please_select')" @change="onPageChange({ page: 1 })" style="width: 130px; margin: -2px -20px">
                      <el-option v-for="item in tableProductList" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                  </el-input>
                </el-form-item>
              </el-form>
            </div>
            <div>
              <el-table v-loading="isLoading" ref="tb2" :size="allTableSize" :data="deviceList" height="400px" @selection-change="selectionChange($event, 'deviceIn')">
                <el-table-column type="selection" width="44" fixed="left" :selectable="onSelectable"></el-table-column>
                <el-table-column prop="productCode" :label="$t('crm_factory_send_plan.chan_pin_xing_hao')" width="120"></el-table-column>
                <el-table-column prop="nextDeviceBizType" :label="$t('crm_factory_send_plan.she_bei_lei_xing')" width="120"></el-table-column>
                <el-table-column prop="bodyNum" :label="$t('crm_factory_send_plan.ji_shen_hao')" width="160"></el-table-column>
                <el-table-column prop="stockDays" :label="$t('crm_factory_send_plan.zai_ku_tian_shu')"></el-table-column>
              </el-table>
            </div>
            <div class="table-page">
              <custom-page layout="total,prev,pager,next,jumper" :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
            </div>
          </div>
          <div class="ubv ub-ac ub-xc" style="padding: 0 18px">
            <div class="btn" @click="onDeviceIn">
              <i class="el-icon-arrow-right"></i>
            </div>
            <div class="btn2" @click="onDeviceOut">
              <i class="el-icon-arrow-left"></i>
            </div>
          </div>
          <div class="ub-f1" style="width: 0">
            <div class="search-hd">
              <el-form :inline="true" @submit.native.prevent>
                <el-form-item>
                  <h1 class="title">{{ $t('crm_factory_send_plan.fa_huo_biao') }}</h1>
                </el-form-item>
              </el-form>
            </div>
            <div>
              <el-table ref="tb3" :size="allTableSize" :data="selectDevice" height="400px" @selection-change="selectionChange($event, 'deviceOut')">
                <el-table-column type="selection" width="44" fixed="left" :selectable="onSelectable"></el-table-column>
                <el-table-column prop="productCode" :label="$t('crm_factory_send_plan.chan_pin_xing_hao')" width="120"></el-table-column>
                <el-table-column prop="nextDeviceBizType" :label="$t('crm_factory_send_plan.she_bei_lei_xing')" width="120"></el-table-column>
                <el-table-column prop="bodyNum" :label="$t('crm_factory_send_plan.ji_shen_hao')" width="160"></el-table-column>
                <el-table-column prop="stockDays" :label="$t('crm_factory_send_plan.zai_ku_tian_shu')"></el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
        <el-button type="primary" @click="saveInsert" :disabled="!selectDevice.length">{{ $t('Common.com_confirm') }}</el-button>
      </div>
    </custom-dialog>
    <!-- 物流单号 -->
    <enter-logistics-no-dialog v-if="editDialog" :model="editModel" @close="editDialog = false" @confirm="onEditSuccess"></enter-logistics-no-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';
import enterLogisticsNoDialog from '@/components/enterLogisticsNoDialog.vue';

export default {
  components: { enterLogisticsNoDialog },
  mixins: [dialogMixins],
  data() {
    return {
      isLoading: false,
      tableList: [],
      tableProductList: [],
      deviceList: [], // 库存
      selectDevice: [], // 已选
      deviceIn: [],
      deviceOut: [],
      formSearch: {
        search: '',
        isShip: true,
        orderDeliveryId: '',
        productCodes: '',
        pageNum: 1,
        pageSize: 20,
      },
      totalRows: 0,
      editModel: {},
      editDialog: false,
    };
  },
  mounted() {
    this.getPlanGoodsList();
  },
  methods: {
    // 获取计划设备
    getPlanGoodsList: function () {
      this.$getJSON(apis.shipPlanGoods, {
        orderDeliveryId: this.model.data.orderDeliveryId,
      }).then((res) => {
        this.tableList = res.data.goodsList;
        const productCodeList = this.tableList.map(t => t.productCode);
        this.tableProductList = [...new Set(productCodeList)];
        this.formSearch.productCodes = [...new Set(productCodeList)];
        this.formSearch.orderDeliveryId = this.model.data.orderDeliveryId;
        this.tableList.forEach((item) => {
          if (item.bodyNum) {
            const arr = item.bodyNum.split(',').map(t => ({ isExists: true, bodyNum: t, productCode: item.productCode, nextDeviceBizType: item.deviceBizType, stockDays: '-' }));
            this.selectDevice = [...this.selectDevice, ...arr];
          }
        });
        this.getDeviceList();
      });
    },
    // 可发货设备列表
    getDeviceList: function () {
      this.isLoading = true;
      this.$getJSON(apis.shipPlanDeviceSelect, this.formSearch).then((res) => {
        this.isLoading = false;
        this.deviceList = res.data.list;
        this.totalRows = res.data.total;
      }).catch(() => {
        this.isLoading = false;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getDeviceList();
    },
    // 加入
    onDeviceIn: function () {
      this.deviceIn.forEach((item) => {
        const has = this.selectDevice.find(t => t.deviceId === item.deviceId);
        if (!has) {
          this.selectDevice.push(item);
        }
      });
      this.$refs.tb2.clearSelection();
    },
    // 移除
    onDeviceOut: function () {
      this.deviceOut.forEach((item) => {
        this.selectDevice = this.selectDevice.filter(t => t.deviceId !== item.deviceId);
      });
    },
    // 保存新增
    saveInsert: function () {
      this.editModel.title = this.$t('crm_factory_send_plan.lu_ru_wu_liu_dan_hao');
      this.editModel.companyCode = this.model.detail.logisticsCompanyCode;
      this.editModel.companyName = this.model.detail.logisticsCompanyName;
      this.editDialog = true;
    },
    // 最终提交
    onEditSuccess: function (param) {
      this.$postJSON(apis.shipPlanSave, {
        deviceList: this.selectDevice,
        customShipmentNum: this.model.data.customShipmentNum,
        orderClass: this.model.orderClass,
        logisticsCompanyCode: param.companyCode,
        logisticsCompany: param.companyName,
        shipmentNum: param.orderNo,
      }).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.$emit('success');
        this.visible = false;
      });
    },
  },
};
</script>

<style lang="scss">
.factory-send-dialog {
  .el-table {
    border-left: 1px solid #eef2f8;
    border-right: 1px solid #eef2f8;
  }

  .el-input-group__prepend {
    font-size: 0;
    border-radius: 2px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .title {
    color: #000000;
    font-weight: bold;
    font-size: 14px;
  }
  .btn {
    cursor: pointer;
    width: 24px;
    height: 24px;
    line-height: 22px;
    border-radius: 4px;
    background-color: #00afff;
    border: 1px solid rgba(24, 144, 255, 1);
    text-align: center;
    color: #ffffff;
  }
  .btn2 {
    cursor: pointer;
    border-radius: 4px;
    width: 24px;
    height: 24px;
    line-height: 22px;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.15);
    text-align: center;
    color: #000000;
    margin-top: 10px;
  }
}
</style>
